import React, { useMemo } from "react";

import { Settings } from "settings";

function median(arr: number[]): number | undefined {
  if (!arr.length) return undefined;
  const s = [...arr].sort((a, b) => a - b);
  const mid = Math.floor(s.length / 2);
  return s.length % 2 === 0 ? (s[mid - 1] + s[mid]) / 2 : s[mid];
}

export class PubsubStatsCollector {
  private pingRtt: number[] = [];

  private rollingPingRTT: number[] = [];

  public resetStats() {
    this.pingRtt = [];
  }

  public addPingRecord(rtt: number) {
    this.pingRtt.push(rtt);
    this.rollingPingRTT.push(rtt);
    if (this.rollingPingRTT.length > Settings.PUBSUB.ROLLING_PING_RTT_LENGTH) {
      this.rollingPingRTT.shift();
    }
  }

  public getStats() {
    if (this.pingRtt.length === 0) {
      return null;
    }
    return {
      pingRtt: {
        isHigh: this.isPingHigh(),
        isLow: this.isPingLow(),
        max: Math.max(...this.pingRtt),
        median: median(this.pingRtt),
        min: Math.min(...this.pingRtt),
      },
    };
  }

  public isPingHigh() {
    const rollingMax = Math.max(...this.rollingPingRTT);
    const rollingMedian = median(this.rollingPingRTT);
    if (rollingMax >= Settings.PUBSUB.POOR_CONNECTION_EXTREME_PING_THRESHOLD) {
      return true;
    }
    if (
      rollingMax >= Settings.PUBSUB.POOR_CONNECTION_MAX_PING_THRESHOLD &&
      rollingMedian &&
      rollingMedian >= Settings.PUBSUB.POOR_CONNECTION_MEDIAN_PING_THRESHOLD
    ) {
      return true;
    }
    return false;
  }

  public isPingLow() {
    const rollingMax = Math.max(...this.rollingPingRTT);
    const rollingMedian = median(this.rollingPingRTT);
    if (
      rollingMax < Settings.PUBSUB.GOOD_CONNECTION_MAX_PING_THRESHOLD &&
      rollingMedian &&
      rollingMedian < Settings.PUBSUB.GOOD_CONNECTION_MEDIAN_PING_THRESHOLD
    ) {
      return true;
    }
    return false;
  }
}

// eslint-disable-next-line react-refresh/only-export-components
export const PubsubStatsCollectorContext = React.createContext<PubsubStatsCollector | null>(null);

export const PubsubStatsCollectorProvider = ({ children }: { children: React.ReactNode }) => {
  const contextValue = useMemo(() => new PubsubStatsCollector(), []);
  return (
    <PubsubStatsCollectorContext.Provider value={contextValue}>
      {children}
    </PubsubStatsCollectorContext.Provider>
  );
};
